
import { ACTION_PERMISSIONS ,DocumentIdName } from './Enums';
import { managerPermissions, magasinierPermissions, commercialPermissions } from './role';

export const generateNumeroDoc=()=> {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
}

export const formatDate = (date) => {
    if (!(date instanceof Date)) {
      date = new Date(date);
      if (isNaN(date)) return "Invalid Date"; // Handle invalid dates
    }
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };
  
  export const formatQuantity = ({
    isVenteDetail,
    quantity,
    nombreDePiece = 1, // Par défaut, un carton contient 24 canettes
    primaryUnit = "carton",
    secondaryUnit = "canette",
  }) => {
    if (!isVenteDetail) {
      // Si vente en poids ou autre unité principale
      return `${quantity.toFixed(2)} ${primaryUnit}`;
    }
  
    // Calcul pour les cartons et canettes
    const sign = Math.sign(quantity); // Retient le signe de la quantité (-1 ou 1)
    const absoluteQuantity = Math.abs(quantity); // Utilise la valeur absolue pour les calculs
    const totalCartons = Math.floor(absoluteQuantity); // Nombre entier de cartons
    const remainingFraction = absoluteQuantity % 1; // Fraction décimale
    const remainingCanettes = Math.round(remainingFraction * nombreDePiece); // Canettes restantes
  
    // Formater le résultat
    const secondaryPart =
      remainingCanettes > 0 ? ` et ${remainingCanettes} ${secondaryUnit}` : "";
    const result = `${totalCartons} ${primaryUnit}${secondaryPart}`;
  
    // Ajoute le signe négatif si nécessaire
    return sign < 0 ? `-${result}` : result;
  };
  

export const checkCreatePermissionBasedOnMouvementType = (selectedMouvementType) => {
  switch (selectedMouvementType) {
    case DocumentIdName.LIVRAISON: //entree de stock
      return ACTION_PERMISSIONS.ADD_BON_DE_LIVRAISON;
    case DocumentIdName.ENTREE_STOCK:
      return ACTION_PERMISSIONS.ADD_ENTREE;
    case DocumentIdName.SORTIE_STOCK:
      return ACTION_PERMISSIONS.ADD_SORTIE;
    case DocumentIdName.ORDRE_DE_LIVRAISON:
      return ACTION_PERMISSIONS.ADD_ORDRE_DE_LIVRAISON;
    case DocumentIdName.COMMANDE_CLIENT:
        return ACTION_PERMISSIONS.ADD_COMMANDE;
    default:
 
      return null;
  }

};

export const checkUpdatePermissionBasedOnMouvementType = (selectedMouvementType) => {
  switch (selectedMouvementType) {
    case DocumentIdName.LIVRAISON: //entree de stock
      return ACTION_PERMISSIONS.EDIT_BON_DE_LIVRAISON;
    case DocumentIdName.ENTREE_STOCK:
      return ACTION_PERMISSIONS.EDIT_ENTREE;
    case DocumentIdName.SORTIE_STOCK:
      return ACTION_PERMISSIONS.EDIT_SORTIE;
    case DocumentIdName.ORDRE_DE_LIVRAISON:
      return ACTION_PERMISSIONS.EDIT_ORDRE_DE_LIVRAISON;
    case DocumentIdName.COMMANDE_CLIENT:
        return ACTION_PERMISSIONS.EDIT_COMMANDE;
    default:
      console.error('Unknown movement type');
      return null;
  }

};

export const checkDeletePermissionBasedOnMouvementType = (selectedMouvementType) => {
  switch (selectedMouvementType) {
    case DocumentIdName.LIVRAISON: //entree de stock
      return ACTION_PERMISSIONS.DELETE_BON_DE_LIVRAISON;
    case DocumentIdName.ENTREE_STOCK:
      return ACTION_PERMISSIONS.DELETE_ENTREE;
    case DocumentIdName.SORTIE_STOCK:
      return ACTION_PERMISSIONS.DELETE_SORTIE;
    case DocumentIdName.ORDRE_DE_LIVRAISON:
      return ACTION_PERMISSIONS.DELETE_ORDRE_DE_LIVRAISON;
    case DocumentIdName.COMMANDE_CLIENT:
        return ACTION_PERMISSIONS.DELETE_COMMANDE;
    default:
      console.error('Unknown movement type');
      return null;
  }

};
export const getPermissionsByRole=(role) =>{
  switch (role.toLowerCase()) {
    case "manager":
      return managerPermissions;
    case "magasinier":
      return magasinierPermissions;
    case "commercial":
      return commercialPermissions;
    default:
      return { error: "Role inconnu" };
  }
}


export const printSale = (saleData, mouvementType) => {
  const articlesHTML = saleData.articles.map(article => {
    const formattedQuantity = formatQuantity({
      isVenteDetail: article?.article?.isAlowSecondaryUnit,
      quantity: article?.quantity,
      nombreDePiece: article?.article?.unitsQte,
      primaryUnit: article?.article?.primaryUnits,
      secondaryUnit: article?.article?.secondaryUnits,
    });

    return `
      <tr>
        <td>${article.article.name}</td>
        <td>${formattedQuantity}</td>
      </tr>
    `;
  }).join('');

  const htmlContent = `
    <html>
    <head>
        <title>${mouvementType} #${saleData.numero}</title>
        <style>
            body { 
              font-family: 'Arial', sans-serif;
              padding: 40px;
              background-color: #f4f4f4;
            }
            .invoice-container {
              max-width: 800px;
              margin: auto;
              background: #fff;
              padding: 20px;
              border-radius: 8px;
              box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
            }
            .header-section {
              text-align: center;
              border-bottom: 2px solid #333;
              padding-bottom: 10px;
              margin-bottom: 20px;
            }
            h2 {
              margin-bottom: 5px;
              color: #333;
            }
            .info-section {
              display: flex;
              justify-content: space-between;
              padding: 10px;
              border-bottom: 1px solid #ddd;
            }
            .info-section p {
              margin: 5px 0;
            }
            table { 
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td { 
              border: 1px solid #ddd; 
              padding: 10px; 
              text-align: left;
            }
            th {
              background-color: #007BFF;
              color: #fff;
              text-transform: uppercase;
            }
            .total-row {
              font-weight: bold;
              background-color: #f5f5f5;
            }
            .summary {
              text-align: right;
              margin-top: 20px;
              font-size: 16px;
            }
            .footer {
              text-align: center;
              margin-top: 20px;
              font-size: 12px;
              color: #888;
            }
            .signature-section {
              margin-top: 30px;
              font-size: 14px;
            }
            .signature-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 15px;
            }
            .signature-row div {
              width: 48%;
              border-bottom: 1px dotted #000;
              padding-bottom: 15px;
            }
        </style>
    </head>
    <body>
        <div class="invoice-container">
            <div class="header-section">
                <h2>${mouvementType}</h2>
                <p>N° #${saleData.numero}</p>
            </div>

            <div class="info-section">
                <div>
                    <p><strong>Date :</strong> ${new Date(
                      saleData.date
                    ).toLocaleString()}</p>
                    <p><strong>Client :</strong> ${
                      saleData.clientFournisseur
                        ? saleData.clientFournisseur.name
                        : ""
                    }</p>
                </div>
                <div>
                    <p><strong>Note :</strong> ${
                      saleData.extraNote || "N/A"
                    }</p>
                </div>
            </div>

            <h3>Articles</h3>
            <table>
                <thead>
                    <tr>
                        <th>Article</th>
                        <th>Quantité</th>
                    </tr>
                </thead>
                <tbody>
                    ${articlesHTML}
                    <tr class="total-row">
                        <td><strong>Sous-total</strong></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            <div class="summary"></div>

            <!-- Section des signatures et informations manuelles -->
                        <div class="signature-section">
            <div class="signature-row">
              <div><strong>Chauffeur :</strong> ____________</div>
              <div><strong>Magasinier :</strong> ____________</div>
            </div>
            <div class="signature-row">
              <div><strong>Numéro Camion :</strong> ____________</div>
              <div><strong>Client (Signature) :</strong> ____________</div>
            </div>
          </div>


            <div class="footer"><p></p></div>
        </div>

        <script>
            window.onload = function() {
                window.print();
            };
        </script>
    </body>
    </html>
  `;

  const newTab = window.open();
  newTab.document.open();
  newTab.document.write(htmlContent);
  newTab.document.close();
};


export function printTable(data, headers, options = {}) {
  if (!data || !headers || data.length === 0 || headers.length === 0) {
    console.error("Missing data or headers");
    return;
  }

  const { title = "Print Preview", paperHeader = {}, landscape = false } = options;

  const getPrintableValue = (row, header) => {
    if (typeof header.render === 'function') {
      const rendered = header.render(row);
      if (typeof rendered === 'string' || typeof rendered === 'number') return rendered;
      if (rendered?.props?.children) {
        return Array.isArray(rendered.props.children)
          ? rendered.props.children.join('')
          : rendered.props.children;
      }
      return '[rendered]';
    }

    const value = row[header.key];
    if (typeof value === 'boolean') return value ? '✅' : '❌';
    if (value === null || value === undefined) return '';
    if (typeof value === 'object') {
      if ('label' in value) return value.label;
      if ('name' in value) return value.name;
      if ('value' in value) return value.value;
      try {
        return JSON.stringify(value);
      } catch {
        return '[Object]';
      }
    }

    return String(value);
  };

  const paperHeaderHTML = Object.keys(paperHeader).length > 0
    ? `
      <div class="paper-header">
        ${Object.entries(paperHeader).map(([key, value]) => `
          <div><strong>${key}:</strong> ${value}</div>
        `).join('')}
      </div>
      <hr />
    `
    : '';

  const html = `
    <html>
      <head>
        <title>${title}</title>
        <style>
          @media print {
            ${landscape ? "@page { size: landscape; }" : ""}
          }

          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          h1 {
            text-align: center;
            margin-bottom: 10px;
          }

          .paper-header {
            margin-bottom: 10px;
            font-size: 14px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }

          th, td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: left;
            vertical-align: top;
          }

          th {
            background-color: #f5f5f5;
          }

          td {
            font-size: 13px;
          }
        </style>
      </head>
      <body>
        <h1>${title}</h1>
        ${paperHeaderHTML}
        <table>
          <thead>
            <tr>
              ${headers.map(h => `<th>${h.label}</th>`).join('')}
            </tr>
          </thead>
          <tbody>
            ${data.map(row => `
              <tr>
                ${headers.map(h => `<td>${getPrintableValue(row, h)}</td>`).join('')}
              </tr>
            `).join('')}
          </tbody>
        </table>
        <script>
          window.onload = () => window.print();
        </script>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
}


